import React from 'react'
import { isFeatureEnabled, FeatureFlag } from '../../lib/features/featureFlags'

interface FeatureWrapperProps {
  feature: FeatureFlag
  children: React.ReactNode
  fallback?: React.ReactNode
  groupId?: string
}

export const FeatureWrapper: React.FC<FeatureWrapperProps> = ({ 
  feature, 
  children, 
  fallback = null,
  groupId
}) => {
  // Check if feature is enabled (with optional group-specific check)
  const isEnabled = groupId 
    ? isFeatureEnabled(feature) // For now, all features enabled for all groups
    : isFeatureEnabled(feature)

  if (!isEnabled) {
    return <>{fallback}</>
  }
  
  return <>{children}</>
}

// Higher-order component version for class components
export const withFeatureFlag = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  feature: FeatureFlag,
  fallback?: React.ReactNode
) => {
  return (props: P) => (
    <FeatureWrapper feature={feature} fallback={fallback}>
      <WrappedComponent {...props} />
    </FeatureWrapper>
  )
}

// Hook for conditional logic
export const useFeatureFlag = (feature: FeatureFlag, groupId?: string): boolean => {
  return groupId 
    ? isFeatureEnabled(feature) // For now, all features enabled for all groups
    : isFeatureEnabled(feature)
} 